import { render, staticRenderFns } from "./NewUserConfirmation.vue?vue&type=template&id=01168942"
import script from "./NewUserConfirmation.vue?vue&type=script&lang=js"
export * from "./NewUserConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports